import { useEffect, useState } from "react";

import { routes } from "routes";
import { SeeMoreBlock } from "components/blocks";
import { TagLink } from "components/widgets/TagList/TagLink";
import { ITag } from "services/types";
import { useTrendingTags } from "queries";

export const TrendingTags = () => {
  const [tags, setTags] = useState<ITag[]>([]);

  const query = useTrendingTags();

  useEffect(() => {
    if (query.isSuccess && query.data) {
      setTags(query.data);
    }
  }, [query.isSuccess, query.data]);

  return (
    <SeeMoreBlock
      header="🔥️ Trending Porn GIFs Tags"
      more={routes.trendingTags()}
      className="trendingTags canvas"
      list={true}
    >
      {tags.map((tag: ITag, index: number) => (
        <TagLink
          key={tag.name}
          tag={tag}
          counts={true}
        />
      ))}
    </SeeMoreBlock>
  );
};
